import axios from "axios";

export function downloadPostFile(url, params) {
    return axios({
        url: url,
        method: 'POST',
        responseType: 'blob',
        data: params ? params : {},
    }).then((response) => {
        let contentDisposition = response.headers['content-disposition'];
        let filename = contentDisposition.substring(contentDisposition.indexOf('=') + 1);

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    })
}

export function downloadFile(url, params) {
    return axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        params: params ? params : {},
    }).then((response) => {
        let contentDisposition = response.headers['content-disposition'];
        let filename = contentDisposition.substring(contentDisposition.indexOf('=') + 1);

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    })
}

export function downloadFileServlet(url, params) {
    return axios({
        url: url,
        method: 'POST',
        params: params ? params : {},
    }).then((response) => {
        let contentDisposition = response.headers['content-disposition'];
        let filename = contentDisposition.substring(contentDisposition.indexOf('=') + 1);

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    })
}

export function downloadFileNewArch(axiosInstance, url, params) {
    return axiosInstance({
        url: url,
        method: 'GET',
        responseType: 'blob',
        params: params ? params : {},
    }).then((response) => {
        let contentDisposition = response.headers['content-disposition'];
        let filename = contentDisposition.substring(contentDisposition.indexOf('=') + 1);

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    });
}
